"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmailConfirmationRequired = exports.isDeliverySupported = exports.isPaymentRequired = exports.getConfigurationByPlatform = exports.PLATFORM_CONFIGURATION = exports.DEFAULT_PLATFORM_CONFIGURATION = void 0;
const types_1 = require("../types");
exports.DEFAULT_PLATFORM_CONFIGURATION = {
    isDeliverySupported: true,
    isEmailConfirmationRequired: true,
    isPaymentRequired: true,
};
exports.PLATFORM_CONFIGURATION = {
    [types_1.Platform.waitr]: {
        isDeliverySupported: false,
        isEmailConfirmationRequired: false,
        isPaymentRequired: false,
    },
    [types_1.Platform.grubhub]: {
        isDeliverySupported: false,
        isEmailConfirmationRequired: false,
        isPaymentRequired: false,
    },
    [types_1.Platform.biteninja]: {
        isDeliverySupported: false,
        isEmailConfirmationRequired: false,
        isPaymentRequired: false,
    },
    [types_1.Platform.doordash]: {
        isDeliverySupported: false,
        isEmailConfirmationRequired: false,
        isPaymentRequired: false,
    },
    [types_1.Platform.skip]: {
        isDeliverySupported: false,
        isEmailConfirmationRequired: false,
        isPaymentRequired: false,
    },
    [types_1.Platform.uber]: {
        isDeliverySupported: false,
        isEmailConfirmationRequired: false,
        isPaymentRequired: false,
    },
};
/**
 * Takes an order cart and returns fulfillment configuration for the correct platform
 * @param {Platform}
 * @returns a configuration object
 */
function getConfigurationByPlatform(platform) {
    const config = platform && exports.PLATFORM_CONFIGURATION[platform];
    if (!config) {
        return { ...exports.DEFAULT_PLATFORM_CONFIGURATION, isDefault: true };
    }
    return { ...config, isDefault: false };
}
exports.getConfigurationByPlatform = getConfigurationByPlatform;
/**
 * Returns a tuple of result, default stating if the payment is required
 * for the given platform
 */
function isPaymentRequired(platform) {
    const { isPaymentRequired, isDefault } = getConfigurationByPlatform(platform);
    return { isDefault, result: isPaymentRequired };
}
exports.isPaymentRequired = isPaymentRequired;
/**
 * Returns a tuple of result, default stating if delivery is required
 * for the given platform
 */
function isDeliverySupported(platform) {
    const { isDeliverySupported, isDefault } = getConfigurationByPlatform(platform);
    return { isDefault, result: isDeliverySupported };
}
exports.isDeliverySupported = isDeliverySupported;
/**
 * Returns a tuple of result, default stating if the email confirmation
 * is required for the given platform
 */
function isEmailConfirmationRequired(platform) {
    const { isEmailConfirmationRequired, isDefault } = getConfigurationByPlatform(platform);
    return { isDefault, result: isEmailConfirmationRequired };
}
exports.isEmailConfirmationRequired = isEmailConfirmationRequired;
//# sourceMappingURL=fulfillment.js.map